import { render, staticRenderFns } from "./NutrientModal.vue?vue&type=template&id=360ae746&scoped=true"
import script from "./NutrientModal.vue?vue&type=script&lang=js"
export * from "./NutrientModal.vue?vue&type=script&lang=js"
import style0 from "./NutrientModal.vue?vue&type=style&index=0&id=360ae746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ae746",
  null
  
)

export default component.exports